export interface ComparedValue {
  current: number
  previous: number
  diff: number
}

export interface UserBase {
  email: string
  first_name: string | null
  last_name: string | null
  image_url: string | null
}

// Media
export enum UsersMediaSortBy {
  SONGS_PLAYED = 'songs_played',
  VIDEOS_VIEWED = 'videos_viewed',
  LIVESTREAM_PARTICIPATION = 'livestream_participation'
}

export interface UsersMediaItem extends UserBase {
  songs_played: ComparedValue
  videos_viewed: ComparedValue
  livestream_participation: ComparedValue
}

export interface UsersMediaPage {
  total: number
  items: UsersMediaItem[]
}

// Events
export enum UsersEventsSortBy {
  BUY_NOW_CLICKS = 'buy_now_clicks',
  PRESALE_CODES = 'presale_codes',
  MEET_AND_GREET = 'meet_and_greet',
  VIP = 'vip',
  RSVP = 'rsvp'
}

export interface UsersEventsItem extends UserBase {
  buy_now_clicks: ComparedValue
  presale_codes: ComparedValue
  meet_and_greet: ComparedValue
  vip: ComparedValue
  rsvp: ComparedValue
}

export interface UsersEventsPage {
  total: number
  items: UsersEventsItem[]
}

// Forum
export enum UsersForumSortBy {
  VIEWS = 'views',
  POSTS = 'posts',
  COMMENTS = 'comments',
  UPVOTES = 'upvotes'
}

export interface UsersForumItem extends UserBase {
  views: ComparedValue
  posts: ComparedValue
  comments: ComparedValue
  upvotes: ComparedValue
}

export interface UsersForumPage {
  total: number
  items: UsersForumItem[]
}

// Chat
export enum UsersChatSortBy {
  MESSAGES = 'messages'
}

export interface UsersChatItem extends UserBase {
  messages: ComparedValue
}

export interface UsersChatPage {
  total: number
  items: UsersChatItem[]
}

// Totals (Summary)
export type ActivityType = 'media' | 'events' | 'forum' | 'chat'

export interface UserTotals extends UserBase {
  score: number
}

export interface UsersTotals {
  activity_type: ActivityType
  users: UserTotals[]
}
